import { Controller } from "@hotwired/stimulus"
import { debounce } from "lodash-es"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["form", "results"]
  static values = {
    url: String,
    debounce: { type: Number, default: 300 }
  }

  private urlValue: string
  private debounceValue: number
  private formTarget: HTMLFormElement
  private resultsTarget: HTMLElement

  initialize() {
    this.submit = debounce(this.submit.bind(this), this.debounceValue)
  }

  search(event) {
    this.submit()
  }

  async submit() {
    const url = new URL(this.urlValue, window.location.origin)
    const formData = new FormData(this.formTarget)
    const params = new URLSearchParams(
      Array.from(formData.entries()).map(([key, value]) => [key, value.toString()])
    )
    url.search = params.toString()

    const response = await fetch(url, {
      headers: {
        Accept: 'text/vnd.turbo-stream.html'
      }
    })
    if (!response.ok) return

    const html = await response.text()
    const template = document.createElement('template')
    template.innerHTML = html
    const stream = template.content.firstElementChild
    if (stream) {
      Turbo.renderStreamMessage(stream.outerHTML)
    }
  }
}
